import { defineMessages } from "../define";

/** The station tablet app (/station): sign-in, picking the pizza, photographing it, its photos. */
export default defineMessages({
  en: {
    "station.title": "Pizza Checker",
    "station.menu": "Menu",
    "station.reload": "Reload the pizzas",
    "station.signOut": "Sign out",
    "station.retry": "Try again",
    "station.error.unknown": "Unknown error",
    "station.error.network": "No connection to the server ({error}).",

    "station.login.description": "Sign in with the account of this tablet.",
    "station.login.login": "Login",
    "station.login.password": "Password",
    "station.login.submit": "Sign in",
    "station.login.invalid": "Wrong login or password.",
    "station.login.refused": "Sign-in refused: {error}",
    "station.login.notStation": "This is no account of a station tablet. Sign in with the tablet's account.",

    "station.products.search": "Search pizza…",
    "station.products.clear": "Clear the search",
    "station.products.recent": "Recently",
    "station.products.mostUsed": "Most used",
    "station.products.all": "All pizzas",
    "station.products.regular": "Pizzas",
    "station.products.mini": "MINI pizzas",
    "station.products.found": "Found",
    "station.products.none": "The catalog has no pizza yet.",
    "station.products.noMatch": "No pizza matches.",
    "station.products.failed": "Could not load the pizzas: {error}",

    "station.capture.picked": "Under the camera",
    "station.capture.photograph": "Photograph",
    "station.capture.capturing": "Photographing…",
    "station.capture.done": "Photographed",
    "station.capture.next": "Next pizza",
    "station.capture.nextIn": "Next pizza ({seconds})",
    "station.capture.change": "Pick another pizza",
    "station.capture.offline": "No connection to the server. Check the Wi-Fi and try again.",
    "station.capture.noCamera": "No camera is assigned to this branch.",
    "station.capture.cameraFailed": "The camera did not take the photo. Check that it is on and connected, then try again.",
    "station.capture.disabled": "Photographing is switched off for this branch.",
    "station.capture.noBranch": "This account has no branch.",
    "station.capture.failed": "Photographing failed.",

    "station.photo.loading": "The photo is on its way…",
    "station.photo.missing": "The photo did not arrive.",
    "station.photo.failed": "Could not load the photo: {error}",
    "station.photo.open": "Show the photo over the whole screen",
    "station.photo.close": "Close",

    "station.recent.title": "Last photos",
    "station.recent.none": "No pizza has been photographed here yet.",
    "station.recent.failed": "Could not load the last photos: {error}",
  },
  cs: {
    "station.title": "Pizza Checker",
    "station.menu": "Nabídka",
    "station.reload": "Znovu načíst pizzy",
    "station.signOut": "Odhlásit",
    "station.retry": "Zkusit znovu",
    "station.error.unknown": "Neznámá chyba",
    "station.error.network": "Bez spojení se serverem ({error}).",

    "station.login.description": "Přihlaste se účtem tohoto tabletu.",
    "station.login.login": "Přihlašovací jméno",
    "station.login.password": "Heslo",
    "station.login.submit": "Přihlásit",
    "station.login.invalid": "Špatné jméno nebo heslo.",
    "station.login.refused": "Přihlášení odmítnuto: {error}",
    "station.login.notStation": "Tohle není účet tabletu stanice. Přihlaste se účtem tabletu.",

    "station.products.search": "Hledat pizzu…",
    "station.products.clear": "Smazat hledání",
    "station.products.recent": "Naposledy",
    "station.products.mostUsed": "Nejčastější",
    "station.products.all": "Všechny pizzy",
    "station.products.regular": "Pizzy",
    "station.products.mini": "MINI pizzy",
    "station.products.found": "Nalezené",
    "station.products.none": "Katalog zatím nemá žádnou pizzu.",
    "station.products.noMatch": "Žádná pizza neodpovídá.",
    "station.products.failed": "Pizzy se nepodařilo načíst: {error}",

    "station.capture.picked": "Pod kamerou",
    "station.capture.photograph": "Vyfotit",
    "station.capture.capturing": "Fotím…",
    "station.capture.done": "Vyfoceno",
    "station.capture.next": "Další pizza",
    "station.capture.nextIn": "Další pizza ({seconds})",
    "station.capture.change": "Vybrat jinou pizzu",
    "station.capture.offline": "Bez spojení se serverem. Zkontrolujte Wi-Fi a zkuste to znovu.",
    "station.capture.noCamera": "K pobočce není přiřazená kamera.",
    "station.capture.cameraFailed": "Kamera nevyfotila. Zkontrolujte, že je zapnutá a připojená, a zkuste to znovu.",
    "station.capture.disabled": "Focení je na této pobočce vypnuté.",
    "station.capture.noBranch": "Účet nemá pobočku.",
    "station.capture.failed": "Focení se nepovedlo.",

    "station.photo.loading": "Fotka se nahrává…",
    "station.photo.missing": "Fotka nedorazila.",
    "station.photo.failed": "Fotku se nepodařilo načíst: {error}",
    "station.photo.open": "Zobrazit fotku přes celou obrazovku",
    "station.photo.close": "Zavřít",

    "station.recent.title": "Poslední fotky",
    "station.recent.none": "Tady se zatím žádná pizza nefotila.",
    "station.recent.failed": "Poslední fotky se nepodařilo načíst: {error}",
  },
});
